import React from 'react';
import PropTypes from 'prop-types';

import { Box, Card, CardContent, Typography } from '@mui/material';

import theme from '../../../../../../theme';
import { BLACK, FEED_BACK } from '../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../theme/fontConstants';
import { epochToDateInReadableFormat } from '../../../../../../utils';

import { isSuspensionActive } from './attendanceStrikeHelpers';

const SuspensionCard = ({ suspension }) => {
  const { start, end, name } = suspension;
  const suspensionActiveColor = isSuspensionActive(end) ? FEED_BACK.RED_75 : BLACK[100];
  return (
    <Card
      key={name}
      sx={{
        mb: 2,
        borderRadius: 2,
        elevation: 0,
        boxShadow: 'none',
        marginY: 2,
        border: `1px solid ${suspensionActiveColor}`,
      }}
    >
      <CardContent
        sx={{
          '&:last-child': {
            paddingBottom: 0,
          },
          padding: theme.spacing(0, 1),
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Typography
            sx={{ fontSize: '20px', fontFamily: PRIMARY_FONT[400], color: suspensionActiveColor }}
          >
            {name}
          </Typography>
          <Typography
            sx={{ fontSize: '20px', fontFamily: PRIMARY_FONT[400], color: suspensionActiveColor }}
          >
            {epochToDateInReadableFormat(start)} - {epochToDateInReadableFormat(end)}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

SuspensionCard.propTypes = {
  suspension: PropTypes.shape({
    name: PropTypes.string,
    start: PropTypes.number,
    end: PropTypes.number,
  }),
};

export default SuspensionCard;
